import Page from 'containers/HomePage'

export default Page
